import React from 'react';

export default function Footer() {
  return (
    <footer style={s.footer}>
      <div style={s.container}>
        
        <div style={s.main}>
          © 2026 <span style={s.brand}>DataSphere</span> — AI-Powered Data Intelligence
        </div>

        <div style={s.sub}>
          support@datasphere.io • Built for modern data teams
        </div>

      </div>
    </footer>
  );
}
const s = {
  footer: {
    padding: '40px 20px',
    borderTop: '1px solid rgba(0,0,0,0.05)',
    background: 'linear-gradient(135deg,#eef2ff,#f8fafc)',
  },

  container: {
    maxWidth: 900,
    margin: '0 auto',
    textAlign: 'center',
  },

  main: {
    fontSize: 14,
    color: 'var(--text-primary)',
    marginBottom: 8,
  },

  brand: {
    fontWeight: 600,
  },

  sub: {
    fontSize: 13,
    color: 'var(--text-muted)',
  },
};